<h1 class="main-title">404</h1>
<h3 class="not-found-subtitle">Not Found</h3>
<span>We couldn't find the page you are looking.</span>
<span>Click <a routerLink="/">here</a> to navigate to home page.</span>
